// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__24lR1","content":"LayoutSettings_content__izyXw"};